<script setup lang="ts">
import {Model} from "@/app/Model";
import PaginazionePenaleLista from "@/components/atomics/PaginazioneAdminPenaleListaPenale.vue";
import FiltriPenaleLista from "@/components/atomics/FiltriAdminPenaleListaPenale.vue";
import ModalAdminPenaleItem from "@/components/atomics/ModalAdminPenaleItem.vue";
import {ref} from "vue";
import {Comms, type IEsito} from "@/app/Comms";
import type {KeyValoreStr, KeyValoreStrNum} from "@/app/data/DataTypes";
import { Modal } from 'bootstrap';
import {ItemPenale} from "@/app/data/PenaleAdmin";

let model: Model = Model.getReactiveInstance();
let comms: Comms = Comms.getInstance();

//components
const paginazione_component = ref(null);
const updatePaginazione = (): void => {
  try {
    //@ts-ignore
    paginazione_component.value.updatePaginazione();
  } catch (e) {
    //console.log("%%%%", e)
  }
}
function callQueryPaginazione(): void {
  callQuery(true);
}
function callQueryFiltri(): void {
  callQuery(false);
}
function updateComponents(): void {
  //PAGINAZIONE
  updatePaginazione();
}
window.addEventListener(
    "listAllRefresh",
    (event) => {
      updateComponents();
    }
);
//@ts-ignore
window.updateComponentsAdminPenale = updateComponents;
//business
function callQuery(soloPaginazione: boolean = false): void {
  Comms.getInstance().penaleAdmin.chiamataPenaleList((e: IEsito) => {
    updateComponents();
  }, soloPaginazione);
}
function editItem(id_doc_master: number = -1): void {
  if (id_doc_master > 0) {
    let canOpen: boolean = false;
    model.pen_admin.itemPenale = new ItemPenale();
    let findPenale: ItemPenale = model.pen_admin.listaPenale.find( (x)=> x.id_doc_master == id_doc_master) as ItemPenale;

    if (findPenale != undefined && findPenale != null) {
      model.pen_admin.itemPenale = findPenale;
      canOpen = true;
    }
    //console.log("%%%%%%%%%%%%%%%%%%% id_doc_master", id_doc_master, "canOpen", canOpen, "findPenale", findPenale, "model.pen_admin.itemPenale", model.pen_admin.itemPenale)
    if (canOpen) {
      const modal = Modal.getOrCreateInstance('#ModalAdminPenaleItem');
      modal.show();
    }
  }
}

//render
function renderCitta(id_localita: string): string {
  let out = id_localita;
  let findCitta: KeyValoreStr | undefined = model.pen_lista_citta.find((x: KeyValoreStr): boolean => { return x.id_localita == id_localita });
  if (findCitta) out = findCitta.citta;
  return out;
}
function renderStatus(status: number): string {
  let out = "text-center status-green";
  if (status > 1) out = "text-center status-red";
  return out;
}
</script>

<template>
  <ModalAdminPenaleItem></ModalAdminPenaleItem>
  <FiltriPenaleLista @recalc="callQueryFiltri()"></FiltriPenaleLista>
  <div class="table-responsive small table-documenti" v-if="model.pen_admin.listaPenale && model.pen_admin.listaPenale.length && model.pen_admin.listaPenale.length > 0">
    <table class="table table-striped table-sm table-admin">
      <thead>
      <tr>
        <th>Id Doc Master</th>
        <th>Status</th>
        <th>Assoluzione Esito</th>
        <th>Assoluzione Motivo</th>
        <th>Capo Imputazione</th>
        <th>Località</th>
        <th>Durata Processo</th>
        <th>Durata Pena</th>
        <th>Giudice</th>
        <th>Importo Evaso</th>
        <th>Importo Risarcimento</th>
        <th>Non Menzione</th>
        <th>Pena Principale</th>
        <th>Data Pronuncia</th>
        <th>Data Sentenza</th>
        <th>Data Elaborazione</th>
        <th>Modifica Manuale</th>

        <th scope="col"> </th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(item, index) in model.pen_admin.listaPenale">
        <tr :id="'docRiga-penale-admin-'+index">
          <td>{{ item.id_doc_master }}</td>
          <td :class="renderStatus(item.id_stato_sen as number)">{{ item.id_stato_sen }}</td>
          <td>{{ item.assoluzione }}</td>
          <td>{{ item.assoluzione_motivo?.join(', ') }}</td>
          <td>{{ item.capo_imputazione_legge?.join(', ') }}</td>
          <td>{{ renderCitta(item.id_localita as string) }}</td>
          <td class="text-center">{{ item.durata_del_processo }}</td>
          <td class="text-center">{{ item.durata_pena?.join(', ') }}</td>
          <td>{{ item.giudice?.join(', ') }}</td>
          <td>{{ item.importo_evaso }}</td>
          <td>{{ item.importo_risarcimento }}</td>
          <td>{{ item.non_menzione_nel_casellario }}</td>
          <td>{{ item.pena_principale?.join(', ') }}</td>
          <td>{{ (item.data_pronuncia_sentenza != null? (new Date(item.data_pronuncia_sentenza as string)).toLocaleDateString() : "") }}</td>
          <td>{{ (item.data!= null? (new Date(item.data as string)).toLocaleDateString() : "") }}</td>
          <td>{{ (item.data_elaborazione!= null? (new Date(item.data_elaborazione as string)).toLocaleDateString() : "") }}</td>
          <td>{{ item.modifica_manuale }}</td>
          <td class="text-right"><a href="javascript:void(0)" :title="'Modifica ' + item.id_doc_master"
                                    @click="editItem(item.id_doc_master)"><i class="bi bi-pencil-square"></i></a></td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>


  <div class="row" v-if="model.pen_admin.listaPenale && model.pen_admin.listaPenale.length && model.pen_admin.listaPenale.length > 0">
    <div class="col-12 col-sm-6 paginazione-label">
      <b>{{ model.pen_admin.paginazionePenale_tot }}</b> Elementi Totali |
      Pagina <b>{{ (model.pen_admin.paginazionePenale_start + 1) }}</b> di
      <b>{{ (model.pen_admin.paginazionePenale_pages + 1) }}</b>
    </div>
    <div class="col-12 col-sm-6">
      <PaginazionePenaleLista ref="paginazione_component" @recalc="callQueryPaginazione()"></PaginazionePenaleLista>
    </div>
  </div>
  <div class="row" v-else>
    <div class="col-12">
      Non sono presenti sentenze
    </div>
  </div>
</template>

<style scoped>

</style>